var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNebelfreiesSpritzen = function SvgNebelfreiesSpritzen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Nebelfreies_spritzen__svg__Ebene_2",
    viewBox: "0 0 81.43 81.43"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Nebelfreies_spritzen__svg__cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:3px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Nebelfreies_spritzen__svg__Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.43 79.93C37.29 79.93 1.5 44.15 1.5 0",
    className: "Nebelfreies_spritzen__svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.43 67.94C43.91 67.94 13.49 37.53 13.49 0",
    className: "Nebelfreies_spritzen__svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.43 57.75C49.54 57.75 23.68 31.9 23.68 0",
    className: "Nebelfreies_spritzen__svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.43 49.09C54.32 49.09 32.34 27.11 32.34 0",
    className: "Nebelfreies_spritzen__svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.43 39.35C59.7 39.35 42.08 21.74 42.08 0",
    className: "Nebelfreies_spritzen__svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.43 31.61c-17.45 0-31.6-14.15-31.6-31.61",
    className: "Nebelfreies_spritzen__svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.43 22.63C68.93 22.63 58.8 12.5 58.8 0M81.43 13.75c-7.59 0-13.75-6.16-13.75-13.75M81.43 4.54c-2.51 0-4.54-2.03-4.54-4.54M.16 79.93h81.27M1.65 81.39 1.51 0",
    className: "Nebelfreies_spritzen__svg__cls-1"
  }))));
};
export default SvgNebelfreiesSpritzen;